import React, { FC } from 'react';
import { Loading } from '../Loading';
import styles from './styles.module.css';

export const NoTableResults: FC<{ loading?: boolean }> = ({ loading }) => {
  return (
    <div className={styles.container} data-testid="no-table-results">
      {loading ? (
        <Loading />
      ) : (
        <>
          <h2 className={styles.heading}>No Results Found</h2>
          <p className={styles.content}>
            Check the name or number and try again
          </p>
        </>
      )}
    </div>
  );
};
